(ns frontend.ui.component.lp-portal.report.body.real-estate.fund.resi.controller
  (:require
   [frontend.ui.component.lp-portal.report.body.real-estate.fund.resi.controller.debt-financing
    :refer [debt-financing]]
   [frontend.ui.component.lp-portal.report.body.real-estate.fund.resi.controller.details-and-figures
    :refer [details-and-figures]]
   [frontend.ui.component.lp-portal.report.body.real-estate.fund.resi.controller.financial-statements
    :refer [financial-statements]]
   [frontend.ui.component.lp-portal.report.body.real-estate.fund.resi.controller.inrev-nav
    :refer [inrev-nav]]
   [frontend.ui.component.lp-portal.report.body.real-estate.fund.resi.controller.overview
    :refer [overview]]
   [frontend.ui.component.lp-portal.report.body.real-estate.fund.resi.controller.tearsheet
    :refer
    [tearsheet]]
   [frontend.ui.component.lp-portal.report.body.real-estate.fund.common.controller :as re]))

(defn ->ui-data
  [{:keys [dynamic-data report-data map-topo] :as props}]
  {:fund-name      (:fund-name report-data)
   :reference-date (:reference-date report-data)
   :tearsheet      (tearsheet (update props :dynamic-path concat [:tearsheet]))
   :overview       (overview (update props :dynamic-path concat [:overview]))
   :inrev-nav      (inrev-nav (update props :dynamic-path concat [:inrev-nav]))
   :debt-financing (debt-financing (update props :dynamic-path concat [:debt-financing]))
   :esg            (re/esg (update props :dynamic-path concat [:esg]))
   :details-and-figures (details-and-figures
                         (update props :dynamic-path concat [:details-and-figures]))
   :financial-statements (financial-statements
                          (update props :dynamic-path concat [:financial-statements]))})
